/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Save_SuccessInputs */

const en_link_editor_save_success = /** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links saved successfully!`)
};

const es_link_editor_save_success = /** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Enlaces guardados con éxito!`)
};

const fr_link_editor_save_success = /** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens enregistrés avec succès !`)
};

const de_link_editor_save_success = /** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links erfolgreich gespeichert!`)
};

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const ja_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const zh_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const ar_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const id_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const it_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const ru_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const pt_link_editor_save_success = en_link_editor_save_success;

/** @type {(inputs: Link_Editor_Save_SuccessInputs) => LocalizedString} */
const ko_link_editor_save_success = en_link_editor_save_success;

/**
* | output |
* | --- |
* | "Links saved successfully!" |
*
* @param {Link_Editor_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_save_success = /** @type {((inputs?: Link_Editor_Save_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Save_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_save_success(inputs)
	if (locale === "es") return es_link_editor_save_success(inputs)
	if (locale === "fr") return fr_link_editor_save_success(inputs)
	if (locale === "de") return de_link_editor_save_success(inputs)
	if (locale === "ja") return ja_link_editor_save_success(inputs)
	if (locale === "zh") return zh_link_editor_save_success(inputs)
	if (locale === "ar") return ar_link_editor_save_success(inputs)
	if (locale === "id") return id_link_editor_save_success(inputs)
	if (locale === "it") return it_link_editor_save_success(inputs)
	if (locale === "ru") return ru_link_editor_save_success(inputs)
	if (locale === "pt") return pt_link_editor_save_success(inputs)
	return ko_link_editor_save_success(inputs)
});